/**
 * 入口
 */

import "@/util/budo_log.js";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import config from "./config";
import service from "./api-service";
import Vant from "vant";
import { Toast } from "vant";
import VueCookies from "vue-cookies";
import VueInfiniteScroll from "vue-infinite-scroll";
import VueMeta from "vue-meta";
import VueUtils from "@/libs/vue-utils";
import filters from "./filter";
import { Lazyload } from "vant";

import "vant/lib/index.css";
import "lib-flexible";

import waterMark from "@/util/waterMark";

import { getPlatform } from "@/libs/common-utils/common-utils";

import { $go_wx_login_url } from "@/util/wx_util";

import { $is_quick_authorize_redirect } from "./page-url-conf.js";

Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueCookies);
Vue.use(VueInfiniteScroll);
Vue.use(VueUtils);
Vue.use(filters);
Vue.use(VueMeta);

import BudoPopup from "@/components/BudoPopup";
Vue.component("BudoPopup", BudoPopup);

window.$budo_toast = function (text) {
  Toast(text);
};

Vue.prototype.$config = config;
Vue.prototype.$service = service;

Toast.setDefaultOptions("loading", { duration: 0, forbidClick: true });

// 指定域名下展示
if (
  location.href.includes("500.cdhuanying.com") ||
  location.href.includes("ls.cdhuanying.com")
) {
  waterMark.set("测试MOV");
}

let platform = getPlatform();
store.commit("setPlatformType", platform);

if (typeof window.entryUrl === "undefined" || window.entryUrl === "") {
  window.entryUrl = location.href.split("#")[0];
}

// 这个页面 如无 sessionStorage access_token 就快速跳登录 不待接口相应再跳 视觉效果更优
var token = sessionStorage.getItem("budo.v4_token_mall");
if (!token && $is_quick_authorize_redirect()) {
  budo_log.info("#53 no token in sessionStorage", location);
  var redirectUrl = location.pathname + location.search + location.hash;
  $go_wx_login_url(redirectUrl);
} else {
  router.afterEach(() => { // 暂存一下
    window["_location_href_"] = location.href;
  })

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
